module.exports = __webpack_public_path__ + "img/person-lines-fill.82b6c7d9.svg";